<div class="modal-header">
  <h3 class="modal-title">Add a Collaborator</h3>
</div>
<div class="modal-body clearfix">
  <div class="container-fluid">
    <div class="col-lg-12">
      <div class="input">
        <input
          #currentFilter
          (keyup)="onKey(currentFilter.value)"
          placeholder="type name here..." />
      </div>
      <div class="user-list">
        <p
          *ngFor="let user of suggestions"
          (click)="onSelect(user)"
          [ngClass]="{ selected: user === selected }">
          <profile-picture [user]="user"></profile-picture>
          <name-tag [user]="user"></name-tag>
        </p>
        <br />
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="closeAndAddParticipant()">
    Add as participant
  </button>
</div>
